import React, { useEffect, useState } from "react";
import { Container, List, Label } from "./styles";
import { useNavigate, useSearchParams } from "react-router-dom";
import api from "../../../services/api";
import { toast } from "react-toastify";
import {
  MdAdd,
  MdDelete,
  MdEdit,
  MdVisibility,
  MdVisibilityOff,
} from "react-icons/md";
import { Button, Modal, Pagination, Select, Spin, Tooltip, Input } from "antd";
import userPhoto from "../../../images/user.png";
import { states } from "../../../services/states";
import { Message, ViewInput, HeaderTitle, Card } from "../../../GlobalStyles";
import { ExclamationCircleFilled } from "@ant-design/icons";
import CountUp from "react-countup";

const { confirm } = Modal;

export default function AdminCredentials() {
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();

  const [loading, setLoading] = useState(true);
  const [credentials, setCredentials] = useState([]);
  const [page, setPage] = useState(() => {
    return Number(searchParams.get("page")) || 0;
  });
  const [credentialsTotal, setCredentialsTotal] = useState(0);
  const [filterSearch, setFilterSearch] = useState(() => {
    return searchParams.get("filter") || "";
  });
  const [state, setState] = useState(() => {
    return searchParams.get("state") || "";
  });
  const [city, setCity] = useState(() => {
    return searchParams.get("city") || "";
  });
  const [service, setService] = useState(() => {
    return searchParams.get("service") || "";
  });
  const [cities, setCities] = useState([]);

  useEffect(() => {
    if (state) {
      const foundState = states.find((item) => item.sigla === state);
      setCities(foundState ? foundState.cidades : []);
    }
  }, [state]);

  useEffect(() => {
    const params = {
      page,
      filter: filterSearch,
      state,
      city,
      service,
    };
    setSearchParams(params, { replace: true });
    listCredentials();
  }, [page, filterSearch, state, city, service]);

  async function listCredentials() {
    setLoading(true);
    let filter = `?page=${page}`;
    if (filterSearch) filter += `&filter=${filterSearch}`;
    if (state) {
      filter += `&state=${state}`;
      if (city) filter += `&city=${city}`;
    }
    if (service) filter += `&service=${service}`;

    await api
      .get(`/admin/list-credentials${filter}`)
      .then((response) => {
        setCredentials(response.data.credentials);
        setCredentialsTotal(response.data.total);
      })
      .catch(({ response }) => {
        if (response?.data?.message) {
          toast.warn(response.data.message);
        } else {
          toast.error("Erro Interno. verifique sua conexão e tente novamente");
        }
      });
    setLoading(false);
  }

  async function deleteCredential(id) {
    await api
      .delete(`/credential/${id}`)
      .then(() => {
        toast.success("Credenciado excluido com sucesso");
        listCredentials();
      })
      .catch(({ response }) => {
        if (response?.data?.message) {
          toast.warn(response.data.message);
        } else {
          toast.error("Erro Interno. verifique sua conexão e tente novamente");
        }
      });
  }

  return (
    <Container>
      <HeaderTitle>
        <h1>Credenciados</h1>
        <Button
          type="primary"
          style={{ borderRadius: 50 }}
          icon={<MdAdd size={20} />}
          onClick={() => navigate(`/admin/new-credential`)}
        >
          Novo Credenciado
        </Button>
      </HeaderTitle>

      <Card>
        <p>Total</p>
        <CountUp separator="." duration={1} end={credentialsTotal} />
      </Card>

      <div className="filters-row">
        <ViewInput style={{ width: 180 }}>
          <p>Estado</p>
          <Select
            showSearch
            allowClear
            optionFilterProp="children"
            value={state || null}
            placeholder="Estado"
            style={{ width: "100%" }}
            onChange={(value) => {
              setState(value);
              setCity("");
              const foundState = states.find((item) => item.sigla === value);
              setCities(foundState ? foundState.cidades : []);
            }}
          >
            {states.map((item) => (
              <Select.Option key={item.sigla} value={item.sigla}>
                {item.nome}
              </Select.Option>
            ))}
          </Select>
        </ViewInput>

        <ViewInput style={{ width: 180 }}>
          <p>Cidade</p>
          <Select
            showSearch
            allowClear
            optionFilterProp="children"
            disabled={!state}
            value={city || null}
            placeholder="Cidade"
            style={{ width: "100%" }}
            onChange={(value) => setCity(value)}
          >
            {cities?.map((item) => (
              <Select.Option key={item} value={item}>
                {item}
              </Select.Option>
            ))}
          </Select>
        </ViewInput>

        <ViewInput style={{ width: 200 }}>
          <p>Serviço</p>
          <Select
            value={service || null}
            allowClear
            placeholder="Serviço"
            style={{ width: "100%" }}
            onChange={(value) => setService(value)}
          >
            <Select.Option value={"Treinamentos"}>Treinamentos</Select.Option>
            <Select.Option value={"Visita Técnica"}>
              Visita Técnica
            </Select.Option>
            <Select.Option value={"Medições ambientais"}>
              Medições ambientais
            </Select.Option>
            <Select.Option value={"Elaboração de PGR, PCMSO LTCAT"}>
              Elaboração de PGR, LTCAT
            </Select.Option>
          </Select>
        </ViewInput>

        <ViewInput style={{ width: 250 }}>
          <p>Pesquisar</p>
          <Input
            placeholder="Nome, email ou cidade"
            value={filterSearch}
            onChange={(e) => setFilterSearch(e.target.value)}
            style={{ width: "100%" }}
            onPressEnter={() => setPage(0)}
          />
        </ViewInput>

        <Button
          type="primary"
          style={{ borderRadius: 50, marginLeft: 10, marginBottom: 5 }}
          onClick={() => setPage(0)}
        >
          Buscar
        </Button>
      </div>

      {loading ? (
        <div
          style={{ display: "flex", justifyContent: "center", padding: 100 }}
        >
          <Spin size="large" color="#008037" />
        </div>
      ) : (
        <>
          <List>
            {credentials.length === 0 && (
              <Message>Nenhum credenciado encontrado</Message>
            )}
            {credentials.map((item) => (
              <div style={{ maxWidth: 280 }} key={item.id}>
                <div className="infos">
                  <p
                    style={{
                      flex: 1,
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                    }}
                  >
                    {item.name}
                  </p>
                  {item.enabled ? (
                    <Tooltip title={item.visible ? "Visível" : "Oculto"}>
                      {item.visible ? (
                        <MdVisibility size={18} color="#008037" />
                      ) : (
                        <MdVisibilityOff size={18} color="#999" />
                      )}
                    </Tooltip>
                  ) : (
                    <Tooltip title="Incompleto">
                      <Label color="#faad14" />
                    </Tooltip>
                  )}
                </div>

                <img
                  src={item.photo ? item.photo_url : userPhoto}
                  alt={item.name}
                />

                <div
                  className="infos"
                  style={{ flexDirection: "column", alignItems: "center" }}
                >
                  <span
                    style={{
                      display: "-webkit-box",
                      WebkitLineClamp: 2,
                      WebkitBoxOrient: "vertical",
                      overflow: "hidden",
                      marginBottom: 8,
                    }}
                  >
                    {item.email}
                  </span>
                  <span
                    style={{
                      display: "-webkit-box",
                      WebkitLineClamp: 2,
                      WebkitBoxOrient: "vertical",
                      overflow: "hidden",
                      marginBottom: 8,
                    }}
                  >
                    {item.description || "Sem descrição informada."}
                  </span>
                  <p style={{ fontSize: 14, color: "#666" }}>
                    {item.city} - {item.state}
                  </p>
                </div>

                <div className="actions">
                  <Tooltip title="Editar">
                    <Button
                      shape="circle"
                      icon={<MdEdit size={18} />}
                      onClick={() => navigate(`/admin/credential/${item.id}`)}
                    />
                  </Tooltip>
                  <Tooltip title="Excluir">
                    <Button
                      shape="circle"
                      danger
                      icon={<MdDelete size={18} />}
                      onClick={() => {
                        confirm({
                          okText: "Confirmar",
                          title: "Excluir Credenciado?",
                          icon: <ExclamationCircleFilled />,
                          content: `Deseja realmente excluir ${item.name}?`,
                          onOk() {
                            deleteCredential(item.id);
                          },
                          cancelText: "Cancelar",
                        });
                      }}
                    />
                  </Tooltip>
                </div>
              </div>
            ))}
          </List>

          <Pagination
            style={{ display: "flex", justifyContent: "center", marginTop: 20 }}
            current={page + 1}
            onChange={(p) => {
              setPage(p - 1);
            }}
            total={credentialsTotal}
            pageSize={30}
            showTotal={(total) => `${total} credenciados`}
          />
        </>
      )}
    </Container>
  );
}
